"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServicePutRequestSchema = void 0;
const yup_1 = require("yup");
const DBReferenceSchema_1 = require("../DBReferenceSchema");
const ServicePutRequestSchema = (0, yup_1.object)().shape({
    id: (0, yup_1.string)().required(),
    customer: DBReferenceSchema_1.DBReferenceSchema,
    reference: (0, yup_1.string)().required(),
    name: (0, yup_1.string)().required(),
    type: (0, yup_1.string)().required(),
    description: (0, yup_1.string)().required(),
    chargeDescription: (0, yup_1.string)().required(),
    ticketReference: (0, yup_1.string)().required(),
    unit: (0, yup_1.string)().required(),
    price: (0, yup_1.number)().required(),
    qty: (0, yup_1.number)().required(),
    total: (0, yup_1.number)().required(),
    start: (0, yup_1.number)().required(),
    end: (0, yup_1.number)().required(),
    defer: (0, yup_1.number)().required(),
});
exports.ServicePutRequestSchema = ServicePutRequestSchema;
